/** Shown when a user tries to start a timer on a task not picked for today. */
export const PICK_BEFORE_TIMER_MESSAGE =
  "Pick this task in Today's Tasks before starting the timer";
